import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
	{ path: `/home`, component: () => import(/* webpackChunkName: "Form" */ `../views/Form`) },
	{ path: `/review`, component: () => import(/* webpackChunkName: "Review" */ `../views/Review`) },
	{
		// We need to allow navigating to /my-registrations, as this is a single page app in a larger multi page app
		path: `/my-registrations`
	},
	{ path: `/`, redirect: `/home` },
	{ path: `/404`, component: () => import(/* webpackChunkName: "404" */ `../views/NotFound`) },
	{ path: `*`, redirect: `/404` }
];

// eslint-disable-next-line no-undef
const router = new VueRouter({ mode: `history`, base: process.env.BASE_URL, routes });

export default router;